<template>
  <div class="card-msg card shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center py-1 px-2">
      <select class="form-control mr-2" v-model="m.type" style="width: 130px">
        <option :value="1">Texto</option>
        <option :value="2">Lista</option>
        <option :value="3">Botões</option>
      </select>
      <div v-if="!child">
        <button class="btn btn-primary btn-sm" type="button" @click="$emit('editAction', m.id)">
          <i class="fa fa-pencil-alt small mr-1"></i> Editar
        </button>
      </div>
    </div>
    <div class="card-body p-2">
      <label class="font-weight-bold small mb-0">Resposta</label>
      <textarea class="form-control mb-2" rows="5" v-model="m.answer" :disabled="!child"></textarea>
    </div>
    <div class="card-footer bg-white px-1 py-2" v-if="m.type !== 1">
      <div class="d-flex align-items-center" v-for="(b, index) in m.actions">
        <span class="px-3">{{index + 1}}</span>
        <input type="text" placeholder="Mensagem do botão" class="form-control m-1 mr-2" v-model="b.text" maxlength="20" required :disabled="!child"/>
        <button class="btn btn-primary btn-sm mr-1" type="button" @click="$emit('editAction', b.id)" v-if="child"
                :disabled="!b.id" :title="!b.id ? 'Salve esta ação antes de editar' : ''" style="width: 32px">
          <i class="fa fa-pencil-alt"></i>
        </button>
        <button class="btn btn-danger btn-sm" type="button" @click="removeAction(m, b)" v-if="child" style="width: 32px"><i class="fa fa-trash"></i></button>
      </div>
      <div class="text-center" v-if="child">
        <button class="btn btn-dark px-4 btn-sm m-1" type="button" @click="addAction(m)"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardMensagem",
  props: ['m', 'child'],
  methods: {
    addAction(m) {
      if (m.type === 3 && m.actions.length >= 3) {
        return;
      }

      if (m.type === 2 && m.actions.length >= 12) {
        return;
      }

      m.actions.push({ text: '', answer: '', type: '1', actions: [] });
    },

    removeAction(m, action) {
      m.actions = m.actions.filter(b => b !== action)
    },
  }
}
</script>

<style scoped>
.card-msg textarea {
  font-size: 14px;
  resize: none;
}
</style>